import { registerOnce } from './Registration'
import WebWidgets from './WebWidgets.vue'

import { WIDGET_SELECTOR } from './constants'  

import { APP } from '@shared/config/constants'

window._appName = APP.DVP.name
window._appGroup = APP.DVP.group

registerOnce(WebWidgets, WIDGET_SELECTOR.SETUP)
